import {createContext} from 'react';

const CancellationFormContext = createContext();

export default CancellationFormContext;
